/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Interview_Practice_Score_LabelInputs */

const en_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Score: ${i?.score}/10`)
};

const de_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bewertung: ${i?.score}/10`)
};

const fr_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Score : ${i?.score}/10`)
};

const es_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puntuación: ${i?.score}/10`)
};

const it_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Punteggio: ${i?.score}/10`)
};

const nl_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Score: ${i?.score}/10`)
};

const pl_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wynik: ${i?.score}/10`)
};

const fi_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pisteet: ${i?.score}/10`)
};

const da_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Score: ${i?.score}/10`)
};

const sv_interview_practice_score_label = /** @type {(inputs: Interview_Practice_Score_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Poäng: ${i?.score}/10`)
};

/**
* | output |
* | --- |
* | "Score: {score}/10" |
*
* @param {Interview_Practice_Score_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_score_label = /** @type {((inputs: Interview_Practice_Score_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Score_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_score_label(inputs)
	if (locale === "fr") return fr_interview_practice_score_label(inputs)
	if (locale === "es") return es_interview_practice_score_label(inputs)
	if (locale === "it") return it_interview_practice_score_label(inputs)
	if (locale === "nl") return nl_interview_practice_score_label(inputs)
	if (locale === "pl") return pl_interview_practice_score_label(inputs)
	if (locale === "fi") return fi_interview_practice_score_label(inputs)
	if (locale === "da") return da_interview_practice_score_label(inputs)
	if (locale === "sv") return sv_interview_practice_score_label(inputs)
	return en_interview_practice_score_label(inputs)
});